import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import _ from "lodash";

import RenderPreviewByType from "../RenderPreviewByType";

import { Form, Input, Button, Radio, Tooltip, Modal, notification } from "antd";
import { FolderViewOutlined, InfoCircleOutlined } from "@ant-design/icons";
import MultipleInput from "../../../MultipleInput/Index";
import EditMedia from "../../../MediaLibrary/EditMedia";
import Config from "../../../../../../config/frontend";
import parseMediaUrl from "../../../../../shared/functions/parseMediaUrl";
import urlParse from "url-parse";
import { t } from "i18next";

const InputField = (props) => {
  const { multipleValue } = props;
  useEffect(() => {
    props.onChange(multipleValue);
  }, [multipleValue]);
  return (
    <div className="player-list-container">
      {props.value?.map((value, index) => (
        <Input key={index} value={value} />
      ))}
    </div>
  );
};

export const InputMultiple = (props) => {
  const { item, form, skipForm, feedType } = props;
  const { labelImage } = item;
  const [openMediaLibrary, setOpenMediaLibrary] = useState(false);
  const [multipleValue, setMultipleValue] = useState(item.value);

  const openModal = (e) => {
    setOpenMediaLibrary(!openMediaLibrary);
  };
  useEffect(() => {
    if (item.value) {
      setMultipleValue(item.value);
    }
  }, [item.value]);

  return (
    <div className={"form-input-multiple"}>
      <Form.Item label={item.label} tooltip={props.tooltip}>
        {!skipForm && (
          <Form.Item name={item.id} noStyle hidden>
            <InputField multipleValue={multipleValue} />
          </Form.Item>
        )}
        {multipleValue && multipleValue?.length > 0 ? (
          <div className="players-preview-block" onClick={openModal}>
            {multipleValue.map((player, index) => (
              <div>{player.player}</div>
              // <RenderPreviewByType
              //   key={mediaUrl + item.updatedAt}
              //   url={mediaUrl}
              //   item={multipleValue}
              // />
            ))}
          </div>
        ) : (
          <div onClick={openModal}>Please add players</div>
        )}
      </Form.Item>

      <Modal
        title="Top Players"
        centered
        open={openMediaLibrary}
        onOk={() => openModal(false)}
        onCancel={() => openModal(false)}
        maskClosable={false}
        width={1000}
      >
        <MultipleInput
          onSelect={(selectedItem) => {
            console.log("on select: ", multipleValue, selectedItem);
            if (!skipForm) {
              const prevPlayers = [...multipleValue];
              const { uuid } = selectedItem;
              const exist = prevPlayers.find((player) => player.uuid === uuid);
              if (exist) {
              } else {
                setMultipleValue([...prevPlayers, selectedItem]);
              }
            }
          }}
          handleRemovePlayer={(item) => {
            console.log("handle remove");
            if (!skipForm) {
              const prevMedias = [...multipleValue];
              const { uuid } = item;
              const newMedias = prevMedias.filter(
                (media) => media.uuid !== uuid,
              );
              setMultipleValue(newMedias);
            }
          }}
          openEditSlideItem={(e, item) => {}}
          onOrderChange={(items) => {
            setMultipleValue(items);
          }}
          onSlideItemChange={(item) => {
            const allItems = [...multipleValue];
            const foundItem = allItems.find(
              (_item) => _item.uuid === item.uuid,
            );
            const { changed } = item;
            const keys = Object.keys(changed);
            const key = keys[0];
            foundItem[key] = changed[key];
            setMultipleValue(allItems);
          }}
          item={item}
          inputs={multipleValue}
          feedType={feedType}
        />
      </Modal>
    </div>
  );
};
